export const toPayKeeper = (action: string , sum: string , orderid: string ): void =>{

    const
        form = document.createElement('form')
        form.action = action || process.env.REACT_APP_PAY_KEEPER || 'https://infocab.server.paykeeper.ru/create/';
        form.method = 'POST'

        const
            sumInput = document.createElement('input')
            sumInput.type ='hidden'
            sumInput.name = 'sum'
            sumInput.value = sum
            form.append(sumInput)

        const
            orderIdInput = document.createElement('input')
            orderIdInput.type = 'hidden'
            orderIdInput.name = 'orderid'
            orderIdInput.value = orderid
            form.append(orderIdInput)

        const
            button = document.createElement('button')
            button.type = 'submit'
            form.append(button)

    document.body.append(form)

    button.click()
    form.remove()}
